export const AssessApi = {
    // 心理测评接口
    psychometrics: '//report1014.acmcoder.com/api/test/report',
    // 心理测评基本信息加密接口
    psychometricsEncryption: '//report1014.acmcoder.com/api/test/report/encryption',

    // 人格测评接口
    personality: '//kaosys.acmcoder.com/api/report/personality',
    // 人格测评基本信息加密接口
    personalityEncryption: '//kaosys.acmcoder.com/api/report/personality/encryption',
    // 人格测评新接口
    candPersonalityNew: '//kaosys.acmcoder.com/api/report/candPersonalityNew',

    // 团队测评接口
    team: '//kaosys.acmcoder.com/api/report/teamlity',
    // 团队测评基本信息加密接口
    teamEncryption: '//kaosys.acmcoder.com/api/report/teamlity/encryption',

    // 潜力行为测评接口
    behavior: '//report1014.acmcoder.com/api/test/report5',
    // 潜力行为测评基本信息加密接口
    behaviorEncryption: '//report1014.acmcoder.com/api/test/report5/encryption',

    // 汇总报告接口
    reportAll: '//report1014.acmcoder.com/api/test/reportAll',
    // 汇总报告基本信息加密接口
    reportAllEncryption: '//report1014.acmcoder.com/api/test/reportAll/encryption',

    // 获取指定项隐私信息-心理测评
    getPsychometricsPrivacy: '//openapi.acmcoder.com/pms/privacy/test/report',
    // 获取指定项隐私信息-人格测评
    getPersonalityPrivacy: '//openapi.acmcoder.com/pms/privacy/test/personality',
    // 获取指定项隐私信息-团队测评
    getTeamPrivacy: '//openapi.acmcoder.com/pms/privacy/test/teamlity',
    // 获取指定项隐私信息-潜力行为测评
    getBehaviorPrivacy: '//openapi.acmcoder.com/pms/privacy/test/report5',
    // 获取指定项隐私信息-汇总报告
    getReportAllPrivacy: '//openapi.acmcoder.com/pms/privacy/test/reportAll',
}


// WEBPACK FOOTER //
// ./src/views/report/config/apis.js